import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "mb-6 text-sm font-semibold",
  "aria-label": "Breadcrumb"
}
const _hoisted_2 = { class: "inline-flex list-none items-center p-0" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  class: "flex min-w-0 items-center",
  "aria-current": "page"
}
const _hoisted_5 = { class: "truncate text-slate-800" }

import { computed } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'AppBreadcrumb',
  props: {
    breadcrumb: {}
  },
  setup(__props: any) {

const props = __props

const breadcrumbLabels: Record<string, string> = {
  'dashboard-pembayaran': 'Dashboard Pembayaran',
  'fakultas': 'Fakultas',
  'kemitraan': 'Kemitraan',
  'kegiatan-kemitraan': 'Kegiatan Kemitraan',
  'transaksi-merchandise': 'Transaksi Merchandise',
  'merchandise-dashboard': 'Dashboard Merchandise',
}

const breadcrumbName = computed(() => {
  const value = props.breadcrumb.trim()
  if (breadcrumbLabels[value]) return breadcrumbLabels[value]

  return value
    .replace(/[-_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ol", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/dashboard",
          class: "text-slate-500 transition hover:text-blue-700"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Dashboard ", -1)
          ]))]),
          _: 1
        }),
        _cache[1] || (_cache[1] = _createElementVNode("svg", {
          class: "mx-3 h-3 w-3 fill-current text-slate-300",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 320 512",
          "aria-hidden": "true"
        }, [
          _createElementVNode("path", { d: "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" })
        ], -1))
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(breadcrumbName.value), 1)
      ])
    ])
  ]))
}
}

})